import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Apis} from "../../../components/api/url";

export const StudentsSetCardPasswordModal = (props: {
    active: boolean,
    closeHandler: any,
    onDone: any,
    pass: string,
}) => {
    const [hasPass, setHasPass] = useState(false);
    const [pass, setPass] = useState('');
    useEffect(() => {
        const isActive = props.active;
        const _pass = props.pass;
        if (isActive) {
            document.body.classList.add('body-no-scroll');
            setPass(_pass);
            setHasPass(_pass !== '');
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active, props.pass]);
    const passId = useId();
    const savePass = () => {
        const _has = hasPass;
        const _pass = pass.trim();
        if (_has && _pass === '') {
            ShowSnackbar(
                'گذرواژه نمی‌تواند خالی باشد.',
                'باشه',
                5000,
            );
            return;
        }
        const _passInt = parseInt(_pass);
        if (_passInt > 9999 || _passInt < 1000) {
            ShowSnackbar(
                'لطفا گذرواژه را بصورت یک عدد چهار رقمی بین 1000 تا 9999 انتخاب کنید.',
                'باشه',
                5000,
            );
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/store/set-pass',
            {
                p: _has ? _pass : '',
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                ShowSnackbar(
                    _has ?
                        'گذرواژه کارت تغییر یافت.' : 'کارت بدون گذرواژه شد.',
                    'باشه',
                    5000,
                );
                props.onDone(!_has ? '' : _pass);
                props.closeHandler();
            },
            () => {
                HideProgressLoading();
            },
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div>
                        <b>ویرایش رمز کارت دانش‌آموز</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="setting-store-max">
                        <button className={"techaran-switch" + (hasPass ? ' active' : '')}
                                onClick={() => setHasPass(v => !v)}
                                style={{paddingTop: 5, paddingBottom: 30}}>
                            <i><b/></i>
                            <span>{hasPass ? 'دارای گذرواژه' : 'بدون گذرواژه'}</span>
                        </button>
                        {
                            hasPass ?
                                <>
                                    <label htmlFor={passId} className="f-roboto">گذرواژه کارت:</label>
                                    <input type="number" className="form-control text-center"
                                           id={passId}
                                           step={1}
                                           min={1000}
                                           max={9999}
                                           value={pass}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setPass(t.trim());
                                           }}
                                    />
                                </>
                                : null
                        }
                        <div className="d-flex justify-content-end" style={{marginTop: 20}}>
                            <button className="btn-pay" onClick={savePass}>
                                <b>ذخیره</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};